import { query, command } from '../api';
import { ApplicationState } from '..';
import { IAnagraficaCustom, DestinatarioCustomModificato, AnagraficaCustomModificata, IUbicazioneCustom, UbicazioneCustom, UbicazioneModificata } from './models';

export const getAnagraficheCustom = (
    state: ApplicationState,
    refreshCache: boolean
) => {
    const cacheType: RequestCache = refreshCache ? "reload" : "default";

    return query<ReadonlyArray<IAnagraficaCustom>>('/api/useradmin/anagrafiche', state, { }, cacheType);
}

export const saveAnagraficheCustom = (
    state: ApplicationState,
    anagrafiche: ReadonlyArray<AnagraficaCustomModificata>, 
    destinatari: ReadonlyArray<DestinatarioCustomModificato>
) => {
    const data = JSON.stringify({ anagrafiche, destinatari });
    
    return command('/api/useradmin/anagrafiche', state, data);
}

/////////////////////////////////////////////////

export const getUbicazioni = (
    state: ApplicationState,
    refreshCache: boolean
) => {
    const cacheType: RequestCache = refreshCache ? "reload" : "default";

    return query<ReadonlyArray<IUbicazioneCustom>>('/api/useradmin/ubicazioni', state, { }, cacheType);
}

export const saveUbicazioniCustom = (
    state: ApplicationState,
    ubicazioni: ReadonlyArray<UbicazioneModificata>
) => {
    const userName = state.core.auth.user!.profile!.email!;
    const data = JSON.stringify({ userName, ubicazioni });
    
    return command('/api/useradmin/ubicazioni', state, data);
}